import { CustomerType } from "../../Enums/CustomerType";

const OPTIONS = [
  { type: CustomerType.IndividualPerson, label: "Pessoa Física" },
  { type: CustomerType.LegalEntity, label: "Pessoa Jurídica" }
];

type PersonTypeToggleProps = {
  value: CustomerType;
  onChange: (type: CustomerType) => void;
  /** Spacing around the toggle, plus a gap that matches the fields below it */
  className?: string;
};

const PersonTypeToggle = ({ value, onChange, className = "gap-3" }: PersonTypeToggleProps) => (
  <div className={`grid grid-cols-2 ${className}`}>
    {OPTIONS.map(({ type, label }) => (
      <button
        key={type}
        type="button"
        aria-pressed={value === type}
        className={`w-full px-1 py-2 rounded-lg text-xs min-[360px]:text-sm whitespace-nowrap font-semibold border ${
          value === type
            ? "bg-primary-600 text-white border-primary-600"
            : "bg-white text-gray-600 border-gray-300 transition-colors hover:bg-primary-50"
        }`}
        onClick={() => onChange(type)}
      >
        {label}
      </button>
    ))}
  </div>
);

export default PersonTypeToggle;
